import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a99397b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["accept"]
const _hoisted_2 = {
  key: 0,
  class: "file-name"
}


import { defineComponent, ref, defineEmits, defineProps } from 'vue'
import { apiPostData, getI18n, isEmptyString } from '../utils'

const __default__ = defineComponent({
  name: 'UploadSingleFileKit'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 上传地址
  srcDataUrl: {
    type: String,
    default: ''
  },
  acceptType: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const refFileInput = ref(null)
const refFileName = ref('')
const props = __props

const uploadsingleFile = (file) => {
  console.log('submit!')

  // 这样提交的只有默认的表单数据，没有文件的数据
  // 创建 FormData 对象
  const formData = new FormData()

  formData.append('__single_file', file) // 添加文件

  // 测试成功， 文件也正常上传了
  apiPostData(props.srcDataUrl, formData)
    .then(data => {
      console.log('onSubmit data=', data)
      refFileName.value = getI18n('上传成功') + ':' + data.file_name
      let fileOriHash = ''
      if (isEmptyString(data.file_ori_hash)) {
        fileOriHash = ''
      } else {
        fileOriHash = data.file_ori_hash
      }
      emit('update:modelValue', '__uploade&&&' + data.file_hash_name + '&&&' + data.file_name + '&&&' + fileOriHash)
    })
}
const triggerFileInput = () => {
  // Trigger the hidden file input when the button is clicked
  refFileInput.value.click()
  console.log('triggerFileInput enter')
}
// 主动实现 通知到 父组件
const emit = __emit // 定义 'update:modelValue' 事件

const handleFileChange = (event) => {
  const file = event.target.files[0]
  if (file) {
    // You can handle the file upload here
    console.log(file.name)
    refFileName.value = file.name
    // Proceed with your custom upload process
    uploadsingleFile(file)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "full-parent" }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        ref_key: "refFileInput",
        ref: refFileInput,
        type: "file",
        accept: props.acceptType,
        onChange: handleFileChange,
        hidden: ""
      }, null, 40, _hoisted_1),
      _createVNode(_component_el_col, {
        span: 18,
        class: "left-align"
      }, {
        default: _withCtx(() => [
          (refFileName.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(refFileName.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        span: 6,
        class: "right-align"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            size: "default",
            type: "primary",
            onClick: triggerFileInput
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getI18n)("上传")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})